import EformBaseService from "../../../../services/EformBaseService";

export default class ForschungsgesuchService extends EformBaseService {
  constructor() {
    super('wbf/bwo/forschungsgesuch')
  }
}
